import { t } from 'i18next'

import { FormGroup, Label } from '~/components/unform'
import ReactSelect from '~/components/unform/ReactSelect'

import { useAdSizeForm } from '../hook/useAdSizeForm'

export const VideoFields = ({
  onChange
}: {
  onChange: (value: AdSizeOption) => void
}) => {
  const { suggestedSizes } = useAdSizeForm()

  return (
    <FormGroup>
      <Label
        text={t('rm:adsize.form.videoResolution.text')}
        helperText={t('rm:adsize.form.videoResolution.helpText')}
        htmlFor="suggestedSize"
        isRequired
      />
      <ReactSelect
        name="suggestedSize"
        options={suggestedSizes}
        onChange={onChange}
        isRequired
      />
    </FormGroup>
  )
}
